"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'branch.edit.title': 'Edytuj Branżę',
};
